import { useMutation, useQuery } from '@tanstack/react-query';
import { notification } from 'antd';
import { APIIntegrationImPACT } from 'lib/api/firebase/apis/api-integration-impact';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useImpactPilotMutations() {
  const addPatient = useMutation({
    mutationFn: APIIntegrationImPACT.addPatient,
    onSuccess: () => {
      notification.open({
        type: 'success',
        message: 'Successfully added the test-taker'
      });
    },
    onError: (error: Error) => {
      notification.open({
        type: 'error',
        message: `Failed to add the test-taker: ${error.message}`
      });
    }
  });
  const generateFakeToken = useMutation({
    mutationFn: APIIntegrationImPACT.generateFakeToken
  });

  const decodeToken = useMutation({
    mutationFn: APIIntegrationImPACT.decodeToken
  });

  return { addPatient, generateFakeToken, decodeToken };
}

/**
 * Check if a token encrypted by ImPACT is valid.
 *
 * This does not require the user to be authenticated.
 *
 * @param token
 * @returns
 */
export function useIsTokenValid(token: string | null) {
  return useQuery({
    queryKey: queryKeyFactory.integration.impact.isTokenValid(token ?? ''),
    enabled: !!token,
    queryFn: () => APIIntegrationImPACT.isTokenValid({ token: token! })
  });
}

export function useDecodeToken(token: string | null) {
  return useQuery({
    queryKey: queryKeyFactory.integration.impact.decodedToken(token ?? ''),
    enabled: !!token,
    queryFn: () =>
      APIIntegrationImPACT.decodeToken({ token: token! }).then(
        _ => _.data.output
      )
  });
}
